<template>
  <div>
    <Header></Header>
    <div class="container">
      <div class="content">
        <div class="row bar">
          <div class="bar-block animate__animated">
            <div>
              <div class="subIcon heicon"></div>
            </div>
            <span>合规</span>
          </div>
          <div class="bar-block animate__animated">
            <div>
              <div class="subIcon xinicon"></div>
            </div>
            <span>信任</span>
          </div>
          <div class="bar-block animate__animated">
            <div>
              <div class="subIcon anicon"></div>
            </div>
            <span>安全</span>
          </div>
          <div class="bar-block animate__animated">
            <div>
              <div class="subIcon kuaiicon"></div>
            </div>
            <span>快捷</span>
          </div>
          <div class="bar-block animate__animated">
            <div>
              <div class="subIcon zhenicon"></div>
            </div>
            <span>真实</span>
          </div>
        </div>
        <div class="business-introduction">
          <div class="business-introduction-title">
            <h3>企业介绍</h3>
            <h4>BUSINESS INTRODUCTION</h4>
          </div>
          <div class="business-introduction-content">
            <p>陕西零工保信息科技有限公司是植根于新经济领域内，具备领先科技的数字服务化供应商。</p>
            <p>公司的核心业务以帮助业态内传统企业战略规划与数字化升级为主，涉及企业财税管理、灵活用工解决方案提供、人力资源规划与培训、</p>
            <p>企业品牌塑造及数字化营销、业态与政策研究和行业标准制定等。旨在以数字新经济变革的视角来探寻行业发展方向，</p>
            <p>为新经济领域的企业赋能，为国家经济在后互联网时代的新旧动能转化助力。</p>
          </div>
          <div class="row advantage">
            <div class="row">
              <!-- @click="start(0,1)" -->
              <i class="iconfont iconqiyegongchangjianzhu2"></i>
              <div>
                <p>
                  <span
                    class="number animate__animated"
                    :class="{number_animate:animateIndex==0}"
                  >{{number1}}</span>
                  <span class="unit">万+</span>
                </p>
                <p>企业认可</p>
              </div>
            </div>
            <div class="row">
              <i class="iconfont iconren"></i>
              <div>
                <p>
                  <span class="number">{{number2}}</span>
                  <span class="unit">万+</span>
                </p>
                <p>创客认可</p>
              </div>
            </div>
            <div class="row">
              <i class="iconfont icon24xiaoshi_day_bg"></i>
              <div>
                <p>
                  <span class="number">{{number3}}</span>
                  <span class="unit">小时</span>
                </p>
                <p>在线服务</p>
              </div>
            </div>
          </div>
          <div class="business-introduction-buttons">
            <button>立即注册</button>
            <button>
              <a style="color:#fff;" href="/website/about_us?tab=0">了解更多</a>
            </button>
          </div>
        </div>
      </div>
      <div class="container service-model container-padding">
        <div class="content">
          <div class="business-introduction-title">
            <h3 class="font-color-1">服务模式</h3>
            <h4>SERVICE MODE</h4>
          </div>
          <div class="row" style="margin-bottom: 38px;">
            <div class="service-model-item service-model-item1">
              <a href="/website/maker?id=3" style="color:#fff;">
                <h3 class="service-model-item-title">放薪管家</h3>
                <p>放薪管家是以科技赋能新就业形态的商税结算，为传统企业或者平台型灵活用工企业提供数字化技术驱动的佣金管理、批量发放、实时支付、纳税申报、开具发票、账单管理、风控管理等一体化系统服务，有云端管理账户和服务接口对接的两种服务模式。</p>
              </a>
            </div>

            <div class="service-model-item service-model-item3">
              <a href="/website/out_source?id=4" style="color:#fff;">
                <h3 class="service-model-item-title">金创客</h3>
                <p>金创客相较于创客而言，利用自己的专业技能有更高的创收能力。针对年收入较高、能够持续创造收入的个人，注册成立个人工作室，企业与金创客直接进行业务合作、资金结算、发票开具等，平台提供商事登记、银行开户、税务申报、代理记账、代开发票等一站式财税服务，可享受园区核定征收的政策。</p>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="container dynamic-state container-padding" style="padding-bottom:0px;">
        <div class="content">
          <div class="business-introduction-title">
            <h3>零工保动态</h3>
            <h4>Dynamic state</h4>
          </div>
          <div style="text-align:right;margin: 0 12px 10px 0;">
            <a style="color:#5fccff" href="/website/news?id=6">查看更多>>></a>
          </div>
          <div class="swiper">
            <swiper class="swiper" :options="swiperOption">
              <swiper-slide
                class="swiper-slide business-introduction-swiper-slide"
                v-for="item in currentList"
                :key="item.code"
              >
                <div class="list-item" style="margin:8px;" @click="goDetail(item.code)">
                  <img
                    :src="item.cover"
                    alt
                    onerror="this.src= 'https://file.lgbfss.com/hr/adff90280bfb01107b2484d11b85a367/bjt.jpg'"
                  />
                  <div>
                    <p class="p-title text-hidden">{{ item.title }}</p>
                    <div>
                      <span class="split-line"></span>
                    </div>
                    <p class="p-content">{{ item.remark }}</p>
                    <p class="time">{{ item.create_time }}</p>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </div>
        </div>
      </div>

      <div class="container contact-form">
        <div class="content">
          <div>
            <h3>即刻拥有你的社会化用工体系</h3>
            <h4 class="contact-form-sub-title">
              <i class="iconfont"></i> 18729372124
            </h4>
          </div>
          <div class="row contact-form-content">
            <input type="text" placeholder="请输入您的姓名或公司名称" />
            <input type="text" placeholder="请输入您的所在城市" />
            <input type="text" placeholder="请输入您的手机号码" />
            <button>点击提交</button>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/header";
import Footer from "../components/footer";
export default {
  data: () => {
    return {
      animateIndex: -1,
      number1: 10,
      number2: 100,
      number3: 24,
      swiperOption: {
        slidesPerView: 3,
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //自动轮播
        autoplay: {
          delay: 2000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: true,
      },
      serviceMarketIndex: 1,
      serviceMarketSubIndex: 1,
      focusdServiceSubItem: "",
      serviceMarketSubMakerList: [
        {
          icon: "icontuandui",
          text: "发布技能",
          image: "https://file.lgbfss.com/www/official/images/test.png",
        },
        {
          icon: "icontuandui",
          text: "基本信息",
          image: "https://file.lgbfss.com/www/official/images/test.png",
        },
        {
          icon: "icontuandui",
          text: "资金明细",
          image: "https://file.lgbfss.com/www/official/images/test.png",
        },
        {
          icon: "icontuandui",
          text: "订单管理",
          image: "https://file.lgbfss.com/www/official/images/test.png",
        },
        {
          icon: "icontuandui",
          text: "合同管理",
          image: "https://file.lgbfss.com/www/official/images/test.png",
        },
      ],
      serviceMarketSubEnterpriseList: [
        {
          icon: "icontuandui",
          text: "发布技能",
          image: "https://file.lgbfss.com/www/official/images/test.png",
        },
        {
          icon: "icontuandui",
          text: "基本信息",
          image: "https://file.lgbfss.com/www/official/images/test.png",
        },
        {
          icon: "icontuandui",
          text: "资金明细",
          image: "https://file.lgbfss.com/www/official/images/test.png",
        },
        {
          icon: "icontuandui",
          text: "订单管理",
          image: "https://file.lgbfss.com/www/official/images/test.png",
        },
        {
          icon: "icontuandui",
          text: "合同管理",
          image: "https://file.lgbfss.com/www/official/images/test.png",
        },
      ],
      currentList: []
    };
  },
  name: "asdcas",
  components: {
    Header,
    Footer,
  },
  mounted: function () {
    this.focusdServiceSubItem = this.serviceMarketSubMakerList[0].image;
    this.getList()
  },
  methods: {
    setServiceMarketIndex (index) {
      this.serviceMarketIndex = index;
    },
    setServiceMarketSubIndex (index) {
      this.serviceMarketSubIndex = index;
    },
    start () {
      this.number1 = 0;
      this.number2 = 0;
      this.number3 = 0;
      let index = 0;
      var a = setInterval(() => {
        index++;
        this.number1 = this.number1 + 1;
        this.number2 = this.number2 + 10;
        if (index % 4 === 0) {
          this.number3 = Math.min(this.number3 + 1, 24);
        }
        if (index === 100) {
          clearInterval(a);
        }
      }, 10);
    },
    getList () {
      this.$axios
        .post(this.$url + '/home.news.list.json', {
          pageSize: 10000,
          pageNumber: 1,
        })
        .then((res) => {
          console.log(res.data.data);
          if (res.data.data.list.length > 0) {
            this.currentList = res.data.data.list;
          }
        })
        .catch((err) => {
          this.msg = err;
        });
    },
    goDetail (id) {
      this.$router.push({
        path: '/news_detail',
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style lang="css" scoped>
.container-padding {
  padding: 50px 0;
}
.business-introduction {
  margin-top: 55px;
  position: relative;
}
.business-introduction-title {
  margin-bottom: 40px;
  text-align: center;
}
.business-introduction-title::after {
  content: " ";
  display: inline-block;
  width: 80px;
  background: #f38200;
  height: 2px;
}
.business-introduction-title h3 {
  text-align: center;
  font-size: 35px;
  font-weight: 600;
  letter-spacing: 5px;
  /* margin-top: 56px; */
}
.business-introduction-title h4 {
  text-align: center;
  color: #cbcbcb;
}
.business-introduction-content {
  text-align: center;
  line-height: 1.5;
}
.advantage {
  margin-top: 36px;
}
.advantage i {
  font-size: 52px;
  color: #707070;
  padding-right: 12px;
}

.advantage .number {
  color: #393939;
  font-weight: 600;
  font-size: 24px;
  display: inline-block;
}

.number_animate {
  animation-name: fadeInUp;
  animation-iteration-count: 10;
  animation-duration: 0.5s;
}

.advantage .unit {
  position: absolute;
  margin-top: -6px;
  font-size: 13px;
}

.bar {
  background: #fff;
  text-align: center;
  color: #7a7a7a;
  height: 104px;
  border-bottom: 1px solid #ccc;
}
.bar-icon {
  font-size: 50px;
}
.bar-block {
  width: 120px;
  height: 100px;
  margin-top: -15px;
  position: relative;
  z-index: 1000;
  padding-top: 20px;
  width: 137px;
  height: 100px;
}
.bar-block > span {
  margin-top: 10px;
  display: inline-block;
}
.bar-block:hover {
  background: #5fccff;
  color: #fff;
  animation-name: bounce;
  animation-iteration-count: 1;
}
.subIcon {
  width: 51px;
  height: 50px;
  margin: 3px auto;
}
.heicon {
  background-image: url("https://file.lgbfss.com/www/official/images/iconhe.png");
}
.xinicon {
  background-image: url("https://file.lgbfss.com/www/official/images/iconxin.png");
}
.anicon {
  background-image: url("https://file.lgbfss.com/www/official/images/iconan.png");
}
.kuaiicon {
  background-image: url("https://file.lgbfss.com/www/official/images/iconkuai.png");
}
.zhenicon {
  background-image: url("https://file.lgbfss.com/www/official/images/iconzhen.png");
}
.bar-block:hover div.heicon {
  background-image: url("https://file.lgbfss.com/www/official/images/iconhebai.png");
}
.bar-block:hover div.xinicon {
  background-image: url("https://file.lgbfss.com/www/official/images/iconxinbai.png");
}
.bar-block:hover div.anicon {
  background-image: url("https://file.lgbfss.com/www/official/images/iconanbai.png");
}
.bar-block:hover div.kuaiicon {
  background-image: url("https://file.lgbfss.com/www/official/images/iconkuaibai.png");
}
.bar-block:hover div.zhenicon {
  background-image: url("https://file.lgbfss.com/www/official/images/iconzhenbai.png");
}
.business-introduction-buttons {
  text-align: center;
  margin: 50px 0;
}
.business-introduction-buttons > button {
  border: none;
  background: #fff;
  padding: 10px 25px;
  color: #fff;
  border-radius: 2px;
}
.business-introduction-buttons > button:first-child {
  background: #5fccff;
  margin-right: 50px;
}
.business-introduction-buttons > button:last-child {
  background: #464646;
}
/* 服务模式 */
.service-model {
  background: url("https://file.lgbfss.com/www/official/images/BrowserPreview_tmp_03.jpg");
}
.service-model-item {
  width: 285px;
  background: #323334;
  opacity: 0.9;
  color: #fff;
  padding: 30px;
}

.service-model-item-title {
  text-align: center;
  font-size: 24px;
  position: relative;
  margin-bottom: 20px;
}
.service-model-item-title::after {
  content: " ";
  display: inline-block;
  width: 40px;
  height: 2px;
  background: #fff;
  position: absolute;
  top: 37px;
  left: 123px;
}
/*  */
.card-title {
  display: flex;
  justify-content: space-between;
  border: 1px solid #ebeef5;
  padding: 15px;
  border-radius: 3px;
  background: #fff;
}
.service-model-item {
}

.business-introduction-block {
  margin: 2px;
  padding: 15px 30px;
  height: 232px;
  background: #ffff;
}
.service-name {
  text-align: center;
  font-size: 22px;
  margin: 18px;
  color: #000;
  font-weight: 600;
}
.business-introduction-block:hover {
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.1);
}
.business-introduction-block:hover .service-name {
  color: #5fccff;
}

.business-introduction-block .company-name {
  color: #989898;
}
.business-introduction-block .company-name:before {
  content: " ";
  display: inline-block;
  height: 12px;
  width: 2px;
  background: #989898;
  margin-right: 10px;
}
.service-content div {
  width: 50%;
  font-size: 14px;
  line-height: 25px;
}
.service-button {
  margin-top: 25px;
  text-align: center;
}
.service-button > button {
  background: #5fccff;
  padding: 10px 25px;
  border: none;
  color: #fff;
  border-radius: 5px;
}
.card-title-text {
  font-weight: 550;
  font-size: 23px;
}

.swiper-button-next {
  margin-right: -42px;
  margin-top: -7px;
  background: #ccc;
  outline: none;
  border-radius: 2px;
  color: #fff;
}
.swiper-button-prev {
  margin-left: -42px;
  margin-top: -7px;
  background: #ccc;
  outline: none;
  border-radius: 2px;
  color: #fff;
}
.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 12px;
}
.card-readmore {
  font-size: 13px;
  color: #b5b5b5;
}

/* 服务市场 */

.service-market {
  background: url("https://file.lgbfss.com/www/official/images/BrowserPreview_tmp_03.jpg");
  padding-bottom: 50px;
}
.service-market-content {
  width: 760px;
  margin: 0 auto;
}
.service-market-content-header {
  display: flex;
  justify-content: space-between;
  background: #fff;
}
.service-market-content-header div {
  flex-grow: 1;
  text-align: center;
  padding: 30px 0;
  font-weight: 600;
}

.service-market-content-header > div.focusTab {
  background: #5fccff;
  color: #fff;
}
.service-market-tab-content {
  background: #fff;
  margin-top: 1px;
  /* padding: 20px 30px; */
}
.service-market-sub-tab {
  flex-grow: 1;
  text-align: center;
  padding: 8px 10px;
}
.service-market-sub-tab.focusd {
  color: #5fccff;
  position: relative;
}
.service-market-sub-tab.focusd::after {
  content: " ";
  position: absolute;
  width: 30px;
  height: 2px;
  background: #5fccff;
  top: 34px;
  left: 62px;
}
.service-market-image {
  width: 720px;
  overflow: hidden;
  padding: 20px;
  background: #fff;
}
.service-market-image img {
  width: 720px;
}

/* 零工动态 */
.dynamic-state {
  background: #f1f3f8;
  padding-bottom: 50px;
}
.dynamic-state-item {
  width: 305px;
  background: #fff;
  padding: 20px;
  margin-top: 20px;
}
.dynamic-state-title {
  font-weight: 550;
}

.dynamic-state-title-split:after {
  content: " ";
  position: relative;
  display: block;
  background: #989898;
  width: 38px;
  height: 1px;
  margin: 15px 0;
}
.dynamic-state-desc {
  color: #888888;
}
.dynamic-state-footer {
  justify-content: space-between;
  margin: 23px 0;
  color: #888;
  margin-bottom: 0px;
  margin-top: 33px;
}
.dynamic-state-footer button {
  background: #5fccff;
  border: none;
  padding: 8px 18px;
  border-radius: 3px;
  border: 1px solid #5fccff;
  color: #fff;
}

.dynamic-state-item:hover {
  background: #5fccff;
}
.dynamic-state-item:hover .dynamic-state-title,
.dynamic-state-item:hover .dynamic-state-desc,
.dynamic-state-item:hover .dynamic-state-footer {
  color: #fff;
}
.dynamic-state-item:hover .dynamic-state-title-split:after {
  background: #fff;
}
.dynamic-state-item:hover .dynamic-state-footer button {
  border: 1px solid #fff;
}

/* 提交 */
.contact-form {
  padding: 50px 0;
  background: #f1f3f8;
}
.contact-form h3 {
  text-align: center;
  font-size: 35px;
  font-weight: 600;
  letter-spacing: 5px;
  margin-top: 56px;
}

.contact-form-sub-title {
  color: #64cdff;
  font-size: 25px;
  text-align: center;
  font-weight: 550;
  margin: 25px;
}
.contact-form-content input {
  width: 310px;
  padding: 10px 5px;
  border: none;
  border: 1px solid #e5e6e8;
}

.contact-form-content button {
  background: #5fccff;
  border: none;
  border-radius: 4px;
  padding: 8px 25px;
  color: #fff;
}

.list-item {
  background-color: #fff;
}
.list-item > div {
  padding: 12px 15px;
}

.list-item:hover {
  background-color: #64cdff;
  color: #ffffff;
}

.list-item > img {
  width: 100%;
  height: 150px;
}

.split-line {
  display: inline-block;
  width: 34px;
  height: 2px;
  background-color: #333333;
}

.list-item:hover .split-line {
  background-color: #ffffff;
}

.list-item p.p-title {
  font-size: 16px;
  margin-top: 12px;
}

.list-item p.p-content {
  line-height: 26px;
  font-size: 14px;
  color: #666666;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box; /* 设置n行，也包括1 */
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.list-item p.time {
  color: #999999;
  font-size: 12px;
}

.list-item:hover p.p-content,
.list-item:hover p.time {
  color: #ffffff;
}
</style>